import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectUtils, SaveSearchService, GlobalService } from '../../shared';
import { ForgetPasswordModel } from '../forget-password/forget-password.model';
import { BaseComponent } from '../../../core/base/base.component';
import { LoaderService, Logger, MyClientServices } from '../../../core';
import { ForgetPasswordService } from '../forget-password/forget-password.service';
import { ChangeService } from 'app/pages/shared/shared';
import { error } from 'util';


@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
  providers: [ForgetPasswordService, ChangeService]
})
export class ForgetPasswordComponent extends BaseComponent {

  forgetPasswordModel: ForgetPasswordModel;
  ngModel: any;
  resetUser: any;
  msg: string;

  constructor(private router: Router,
    protected loaderService: LoaderService,
    protected changeSerive: ChangeService,
    protected globalService: GlobalService,
    protected saveSearchService: SaveSearchService,
    protected forgetPasswordService: ForgetPasswordService,
    protected myClientServices: MyClientServices
  ) {
    super(loaderService, changeSerive, saveSearchService, forgetPasswordService, globalService, myClientServices);

    this.currentClient = myClientServices.getMyClient();
  }

  getLoaderName(): string {
    return 'forgetPassword';
  }

  getSearchModel(): any {
    if (ProjectUtils.isEmpty(this.forgetPasswordModel)) {
      if (ProjectUtils.isEmpty(this.forgetPasswordModel)) {
        this.forgetPasswordModel = new ForgetPasswordModel();
      }
      this.ngModel = this.forgetPasswordModel.username;
    }
    return this.forgetPasswordModel;
  }



  resetuserpass() {
    this.showLoader();
    let body: any = '';
    const publisher = this.currentClient;
    const clientID = this.currentClient;
    body += this.forgetPasswordService.setParamValue(body, 'username', this.forgetPasswordModel.username);
    body += this.forgetPasswordService.setParamValue(body, 'publisher', publisher);
    body += this.forgetPasswordService.setParamValue(body, 'clientID', clientID);
    this.resetUser = this.forgetPasswordService.toresetuser(body).subscribe(userDetails => {
      if (userDetails.length === 0) {
        console.log('userDetails', userDetails[0]);
        this.msg = 'Please Enter Correct Email';
        this.fadeAlertBox();
        // setTimeout(() => {
        //   this.msg = '';
        // }, 3000);
        this.hideLoader();
      }
      else {
        console.log('To_Reset_Username', userDetails);
        if (userDetails['error'] === "null") {
          this.msg = 'Please Enter Username';
          this.fadeAlertBox();
          console.log("Print me some where");
        } else {
          this.router.navigate(['../securityCheckForgotpassComponent'], { queryParams: { user_code: userDetails[0]['user_code'], question: userDetails[0]['question'] } });
          this.hideLoader();
        }

      }
    });
    this.hideLoader();
  }


  fadeAlertBox() {
    // this.msg = 'Please Enter Correct Email';
    $('#alertBox').fadeIn();
    setTimeout(function () {
      $('#alertBox').fadeOut();
    }, 3000);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/forget-password/forget-password.component.ts